import { Controller } from "@hotwired/stimulus"

// Applies Brazilian mobile phone mask: (xx) xxxxx-xxxx
export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.mask.bind(this))
    this.element.addEventListener("keydown", this.handleKeydown.bind(this))
    if (this.element.value) this.mask()
  }

  mask() {
    let v = this.element.value.replace(/\D/g, "").slice(0, 11)
    if (v.length > 10) {
      v = v.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3")
    } else if (v.length > 6) {
      v = v.replace(/^(\d{2})(\d+)/, "($1) $2")
    } else if (v.length > 2) {
      v = v.replace(/^(\d{2})(\d+)/, "($1) $2")
    } else if (v.length > 0) {
      v = v.replace(/^(\d+)/, "($1")
    }
    this.element.value = v
  }

  handleKeydown(event) {
    if (event.key === "Backspace") {
      const pos = this.element.selectionStart
      const val = this.element.value
      // Skip over formatting characters when backspacing
      if (pos > 0 && /[\s\-\(\)]/.test(val[pos - 1])) {
        event.preventDefault()
        this.element.setSelectionRange(pos - 1, pos - 1)
      }
    }
  }
}
